export default __webpack_public_path__ + "static/events-light-b6d00903966f521bf03fe166e52be022.png";